// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"871a43f40ba2ea200d37","655":"31973e9d75648917c7ba"}[chunkId] + ".js";
};